export const productUnits = [
  "Piece",
  "Unit",
  "Pack",
  "Packet",
  "Bundle",
  "Set",
  "Pair",
  "Dozen",
  "Carton",
  "Box",
  "Case",
  "Tray",
  "Roll",
  "Sheet",
  "Bag",
  "Sack",
  "Bottle",
  "Can",
  "Jar",
  "Tube",
  "Pouch",
  "Container",
  "Drum",
  "Barrel",
  "Tank",
  "Kilogram",
  "Gram",
  "Milligram",
  "Metric Ton",
  "Pound",
  "Ounce",
  "Liter",
  "Milliliter",
  "Centiliter",
  "Gallon",
  "Quart",
  "Pint",
  "Cup",
  "Meter",
  "Centimeter",
  "Millimeter",
  "Kilometer",
  "Inch",
  "Foot",
  "Yard",
  "Square Meter",
  "Square Foot",
  "Cubic Meter",
  "Cubic Foot",
  "Hour",
  "Day",
  "Week",
  "Month",
  "Year",
  "Tablet",
  "Capsule",
  "Vial",
  "Ampoule",
  "Strip",
  "Ream",
  "Book",
  "Coil",
  "Bale",
  "Crate",
  "Pallet",
  "Lot",
  "Batch",
];

export const productStatuses = [
  // "Active",
  "Inactive",
  // "Out of Stock",
  // "Low Stock",
  // "Discontinued",
  "Pending Approval",
  "Draft",
  // "Archived",
  // "Damaged",
  // "Expired",
  // "Returned",
  "On Order",
  "Backordered",
];
